import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import QuoteModal from '../../../components/feature/QuoteModal';

const photos = [
  {
    src: "https://public.readdy.ai/ai/img_res/5bfb5735b97dcdfe6c4c4e43e386e68c.jpg",
    alt: "Limpieza de sala",
    span: "col-span-2",
  },
  {
    src: "https://readdy.ai/api/search-image?query=close%20up%20window%20cleaning%20professional%20squeegee%20wiping%20large%20glass%20pane%20residential%20house%20exterior%20bright%20sunlight%20reflection%20crystal%20transparent%20clean%20streak%20free&width=340&height=340&seq=hcol22&orientation=squarish",
    alt: "Limpieza de ventanas",
    span: "col-span-1",
  },
  {
    src: "https://readdy.ai/api/search-image?query=power%20pressure%20washer%20jet%20spray%20cleaning%20dirty%20concrete%20driveway%20patio%20outdoor%20pavement%20before%20after%20transformation%20suburban%20home%20sunny%20day%20strong%20water%20stream&width=340&height=340&seq=hcol33&orientation=squarish",
    alt: "Lavado a presión",
    span: "col-span-1",
  },
  {
    src: "https://readdy.ai/api/search-image?query=immaculate%20spotless%20white%20modern%20kitchen%20after%20deep%20cleaning%20gleaming%20countertops%20stainless%20appliances%20bright%20cabinets%20polished%20surfaces%20residential%20home%20interior%20professional%20result&width=720&height=340&seq=hcol44&orientation=landscape",
    alt: "Limpieza de cocina",
    span: "col-span-2",
  },
  {
    src: "https://readdy.ai/api/search-image?query=pressure%20washing%20cleaning%20house%20exterior%20vinyl%20siding%20white%20walls%20strong%20water%20jet%20outdoor%20residential%20curb%20appeal%20transformation%20clean%20bright%20sunny%20afternoon%20suburban&width=720&height=340&seq=hcol55&orientation=landscape",
    alt: "Lavado exterior",
    span: "col-span-2",
  },
  {
    src: "https://readdy.ai/api/search-image?query=clean%20sparkling%20white%20bathroom%20tiles%20tub%20shower%20professional%20deep%20cleaning%20result%20gleaming%20mirror%20polished%20faucet%20immaculate%20grout%20bright%20residential%20home%20service&width=340&height=340&seq=hcol66&orientation=squarish",
    alt: "Limpieza de baño",
    span: "col-span-1",
  },
];

export default function HeroSection() {
  const [quoteOpen, setQuoteOpen] = useState(false);
  const { t } = useTranslation();

  return (
    <>
      <section className="relative min-h-screen flex items-stretch overflow-hidden bg-[#0b1a2c]">

        {/* ── LEFT: Text content ── */}
        <div className="relative z-20 w-full lg:w-[48%] flex flex-col justify-center px-8 md:px-14 xl:px-20 pt-28 pb-16 min-h-screen">

          <span className="inline-flex items-center gap-2 bg-emerald-500/15 border border-emerald-400/30 text-emerald-400 text-xs font-semibold px-4 py-1.5 rounded-full mb-8 tracking-widest uppercase w-fit">
            <i className="ri-sparkle-line text-sm" />
            {t('hero_badge')}
          </span>

          <h1 className="font-heading font-extrabold text-white text-4xl md:text-5xl xl:text-[3.4rem] leading-[1.12] mb-6">
            {t('hero_title1')}
            <span className="block text-emerald-400 mt-1">{t('hero_title2')}</span>
          </h1>

          <p className="text-white/60 text-base md:text-[1.05rem] max-w-[430px] leading-relaxed mb-10">
            {t('hero_desc')}
          </p>

          <div className="flex flex-col sm:flex-row gap-4 items-start mb-14">
            <button
              onClick={() => setQuoteOpen(true)}
              className="bg-emerald-500 hover:bg-emerald-600 text-white font-semibold px-8 py-3.5 rounded-full flex items-center gap-3 transition-colors cursor-pointer whitespace-nowrap shadow-lg shadow-emerald-900/40"
            >
              <div className="w-6 h-6 flex items-center justify-center rounded-full bg-white/20">
                <i className="ri-calendar-check-line text-sm" />
              </div>
              {t('hero_cta1')}
            </button>
            <a
              href="/servicios"
              className="border-2 border-white/25 text-white hover:border-emerald-400 hover:text-emerald-400 font-semibold px-8 py-3.5 rounded-full flex items-center gap-2 transition-all cursor-pointer whitespace-nowrap"
            >
              {t('hero_cta2')}
              <i className="ri-arrow-right-line" />
            </a>
          </div>

          {/* Stats */}
          <div className="grid grid-cols-3 gap-3 max-w-[380px]">
            {[
              { num: '100%', label: t('hero_stat1'), icon: 'ri-shield-check-line' },
              { num: '24h', label: t('hero_stat2'), icon: 'ri-time-line' },
              { num: 'Gratis', label: t('hero_stat3'), icon: 'ri-price-tag-3-line' },
            ].map((s) => (
              <div key={s.label} className="flex flex-col items-center text-center bg-white/[0.06] rounded-xl py-4 px-2 border border-white/[0.09]">
                <div className="w-8 h-8 flex items-center justify-center text-emerald-400 mb-1">
                  <i className={`${s.icon} text-lg`} />
                </div>
                <p className="font-heading font-bold text-white text-xl">{s.num}</p>
                <p className="text-white/45 text-[0.65rem] mt-0.5 leading-snug">{s.label}</p>
              </div>
            ))}
          </div>
        </div>

        {/* ── RIGHT: Photo collage grid ── */}
        <div className="hidden lg:flex absolute right-0 top-0 w-[54%] h-full flex-col overflow-hidden">
          {/* left-edge dark fade */}
          <div className="absolute left-0 top-0 w-28 h-full bg-gradient-to-r from-[#0b1a2c] to-transparent z-10 pointer-events-none" />
          {/* bottom fade */}
          <div className="absolute bottom-0 left-0 w-full h-24 bg-gradient-to-t from-[#0b1a2c] to-transparent z-10 pointer-events-none" />
          {/* top fade */}
          <div className="absolute top-0 left-0 w-full h-16 bg-gradient-to-b from-[#0b1a2c] to-transparent z-10 pointer-events-none" />

          <div className="grid grid-cols-3 grid-rows-3 gap-2 h-full p-3 pt-20 pb-8">
            {/* Row 1 */}
            <div className="col-span-2 row-span-1 rounded-2xl overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=valet%20trash%20service%20worker%20wearing%20bright%20safety%20vest%20collecting%20small%20garbage%20bags%20walking%20apartment%20condominium%20hallway%20corridor%20door%20to%20door%20residential%20building%20indoor%20uniform%20professional%20smiling&width=720&height=340&seq=hvalet77&orientation=landscape"
                alt="Recolección de basura puerta a puerta"
                className="w-full h-full object-cover hover:scale-105 transition-transform duration-700"
              />
            </div>
            <div className="col-span-1 row-span-1 rounded-2xl overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=close%20up%20window%20cleaning%20professional%20squeegee%20wiping%20large%20glass%20pane%20residential%20house%20exterior%20bright%20sunlight%20reflection%20crystal%20transparent%20clean%20streak%20free&width=340&height=340&seq=hcol22&orientation=squarish"
                alt="Limpieza de ventanas"
                className="w-full h-full object-cover hover:scale-105 transition-transform duration-700"
              />
            </div>

            {/* Row 2 */}
            <div className="col-span-1 row-span-1 rounded-2xl overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=power%20pressure%20washer%20jet%20spray%20cleaning%20dirty%20concrete%20driveway%20patio%20outdoor%20pavement%20before%20after%20transformation%20suburban%20home%20sunny%20day%20strong%20water%20stream&width=340&height=340&seq=hcol33&orientation=squarish"
                alt="Lavado a presión"
                className="w-full h-full object-cover hover:scale-105 transition-transform duration-700"
              />
            </div>
            <div className="col-span-2 row-span-1 rounded-2xl overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=immaculate%20spotless%20white%20modern%20kitchen%20after%20deep%20cleaning%20gleaming%20countertops%20stainless%20appliances%20bright%20cabinets%20polished%20surfaces%20residential%20home%20interior%20professional%20result&width=720&height=340&seq=hcol44&orientation=landscape"
                alt="Limpieza de cocina"
                className="w-full h-full object-cover hover:scale-105 transition-transform duration-700"
              />
            </div>

            {/* Row 3 */}
            <div className="col-span-2 row-span-1 rounded-2xl overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=pressure%20washing%20cleaning%20house%20exterior%20vinyl%20siding%20white%20walls%20strong%20water%20jet%20outdoor%20residential%20curb%20appeal%20transformation%20clean%20bright%20sunny%20afternoon%20suburban&width=720&height=340&seq=hcol55&orientation=landscape"
                alt="Lavado exterior"
                className="w-full h-full object-cover hover:scale-105 transition-transform duration-700"
              />
            </div>
            <div className="col-span-1 row-span-1 rounded-2xl overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=clean%20sparkling%20white%20bathroom%20tiles%20tub%20shower%20professional%20deep%20cleaning%20result%20gleaming%20mirror%20polished%20faucet%20immaculate%20grout%20bright%20residential%20home%20service&width=340&height=340&seq=hcol66&orientation=squarish"
                alt="Limpieza de baño"
                className="w-full h-full object-cover hover:scale-105 transition-transform duration-700"
              />
            </div>
          </div>
        </div>

        {/* ── Mobile background ── */}
        <div className="absolute inset-0 lg:hidden">
          <img
            src="https://readdy.ai/api/search-image?query=professional%20house%20cleaning%20team%20residential%20home%20service%20interior%20spotless%20floors%20bright%20modern%20living%20room%20smiling%20worker%20uniform%20natural%20light%20wide%20angle&width=800&height=1200&seq=hcol_mob2&orientation=portrait"
            alt="Limpieza profesional"
            className="w-full h-full object-cover object-center"
          />
          <div className="absolute inset-0 bg-[#0b1a2c]/82" />
        </div>

        {/* Scroll hint */}
        <div className="absolute bottom-7 left-1/4 -translate-x-1/2 z-20 text-white/30 hidden lg:flex flex-col items-center gap-1">
          <i className="ri-arrow-down-line animate-bounce text-lg" />
        </div>
        <div className="absolute bottom-7 left-1/2 -translate-x-1/2 z-20 text-white/30 flex lg:hidden flex-col items-center gap-1">
          <i className="ri-arrow-down-line animate-bounce text-lg" />
        </div>

      </section>

      <QuoteModal isOpen={quoteOpen} onClose={() => setQuoteOpen(false)} />
    </>
  );
}
